import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}


export const getCircularIndex = <T>(array: T[], index: number): T | undefined => {
  if (!array || array.length === 0) return undefined;

  const length = array.length;
  // Handle negative indices by converting them to positive
  const normalizedIndex = ((index % length) + length) % length;
  return array[normalizedIndex];
};
